export default __webpack_public_path__ + "static/media/1200.6909d261.png";